// tooltips
function cookieAccept() {
  var session = sessionStorage.getItem('acceptCookies_v2');
  var local = localStorage.getItem('acceptCookies_v2');

  if ((session === 'CookiesAccepted') || (local === 'CookiesAccepted')) {
    if ($('.clear-cookie-accept').length) {
      $('.clear-cookie-accept').on('click', function () {
        sessionStorage.removeItem('acceptCookies_v2');
        localStorage.removeItem('acceptCookies_v2');
      });
    }
  } else {
    $('body').prepend('<div class="cookie-accept"><p><b>Notice</b></p><p>' +
    'We have revised our Privacy Policy and Terms of Use.' + 
    'Please read both of these documents as the changes affect your legal rights.' +
    '<br />By continuing you agree to these updates.' + 
      ' <a href="/privacy-policy">Learn more about our Privacy Policy</a>.' + 
      ' <a href="/terms-of-use">Learn more about our Terms of Use</a>.</p>' + 
      '<a class="accept" href="javascript:void(0);">Accept</a><a class="decline" href="javascript:void(0);">Dismiss</a><a class="dismiss" href="javascript:void(0);">&times;</a></div>');
  }
  $('.cookie-accept .accept').on('click', function () {
    localStorage.setItem('acceptCookies_v2', 'CookiesAccepted');
    $('.cookie-accept').remove();
  });
  $('.cookie-accept .decline, .cookie-accept .dismiss').on('click', function () {
    sessionStorage.setItem('acceptCookies_v2', 'CookiesAccepted');
    $('.cookie-accept').remove();
  });
}
